<template>
    <Dialog
        :value="true"
        :header-text="controller.model.getEditTimeEntryDescription() ? $t('Edit comment') : $t('Add comment')"
        persistent
        @close_modal="controller.closeEditTimeEntryDescription()"
    >
        <v-container>
            <text-area-field
                autofocus
                max-length="255"
                :value="valueCopy"
                @input="valueCopy = $event"
            />
        </v-container>
        <template slot="footer">
            <v-spacer />
            <secondary-button @click="controller.closeEditTimeEntryDescription()">
                {{ $t("Cancel") }}
            </secondary-button>
            <primary-button :loading="controller.loader.isLoading" @click="controller.saveEditTimeEntryDescription(valueCopy)">
                {{ $t("Save") }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import { $t } from "@/i18n";
import Dialog from "../../../components/Dialog.vue";
import {ref} from "@vue/composition-api";
import Controller from "./controller";

export default {
    name: "EditTimeEntryCommentDialog",
    components: {
        Dialog
    },
    props: {
        controller: {
            type: Controller,
            required: true
        }
    },
    setup(props, ctx) {
        const valueCopy = ref(null);

        valueCopy.value = props.controller.model.getEditTimeEntryDescription()

        return {
            valueCopy
        }
    }
};
</script>
